module.exports = __webpack_public_path__ + "img/Leung.0c6321e4.jpeg";